import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'
import config from './runtime'

/**
 * Initialize Sentry error tracking and performance monitoring
 */
export const initializeSentry = () => {
    Sentry.init({
        dsn: 'https://d6a63393aa534b208a13d885d805127e@o396255.ingest.sentry.io/5279172',
        environment: config.ENVIRONMENT,
        release: 'heavyworth-web@' + config.npm_package_version,
        integrations: [new Integrations.BrowserTracing()],
        tracesSampleRate: 1.0,
    })
}